import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useNavigate } from 'react-router';

import s from './AccessDenied.module.css';

type AccessDeniedProps = {
  message?: string;
  actionTo?: string;
  actionLabel?: string;
};

function AccessDenied({
  message = "You don't have permission to view this page.",
  actionTo,
  actionLabel,
}: AccessDeniedProps) {
  const navigate = useNavigate();

  return (
    <div className={s.wrap}>
      <div className={s.iconWrap}>
        <LockOutlinedIcon sx={{ fontSize: 30 }} />
      </div>
      <h2 className={s.title}>Access denied</h2>
      <p className={s.message}>{message}</p>
      {actionTo && actionLabel && (
        <button type="button" className={s.actionBtn} onClick={() => navigate(actionTo)}>
          {actionLabel}
        </button>
      )}
    </div>
  );
}

export default AccessDenied;
